import React from 'react'
import "@fontsource/plus-jakarta-sans";
const WhatWe = () => {
  const partnerImage = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/we.svg';


  return (
    <div className='container juystify-content-center align-item-center text-center 'style={{padding:'20px'}}>
        <h1 className='font-25' style={{color:'#252525',fontSize:'40px',fontWeight:'700',fontFamily: "'Plus Jakarta Sans', sans-serif"}}>What We Do</h1>
            <img
        src={partnerImage}
        alt="Partner Image"
        style={{ maxWidth: '100%', height: 'auto' ,marginTop:'10px'}}
      />
        <p className=''style={{fontSize:'16px',fontWeight:'400',marginTop:'20px',fontFamily: "'Plus Jakarta Sans', sans-serif"}}>At DataMetricks, we offer a full range of services that combine top-tier web development with<br/>
         powerful marketing strategies to give your business the online boost it needs. Our core<br/> services include:
    </p>
    </div>
  )
}

export default WhatWe